import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import './SignUpLink.scss';

export default function SignUpLink() {
  const currentLang = useSelector((state) => state.intl.locale);

  return (
    <Link to={`/${currentLang}/signup`} className="signup-button">
      <FormattedMessage id="free_trial" defaultMessage="14 days free trial" />
    </Link>
  );
}
